import indexOf from "lodash/indexOf";

export const getFirstIncompleteStepIndex = (stepsCompleteness: boolean[]): number => {
  const firstIncompleteStepIndex = indexOf(stepsCompleteness, false);

  return firstIncompleteStepIndex === -1 ? stepsCompleteness.length : firstIncompleteStepIndex;
};
